import { render } from "./FakeIframe.vue?vue&type=template&id=52faf386&scoped=true&ts=true"
import script from "./FakeIframe.vue?vue&type=script&lang=ts"
export * from "./FakeIframe.vue?vue&type=script&lang=ts"

import "./FakeIframe.vue?vue&type=style&index=0&id=52faf386&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52faf386"]])

export default __exports__